/*
JSON Format exampl
{
  "XS": {
    "BUST": "58 - 63CM",
    "CUP": "11 - 11CM"
  },
  "S": {
    "BUST": "64 - 71CM",
    "CUP": "22 - 22CM"
  },
  "M": {
    "BUST": "72 - 79CM",
    "CUP": "33 - 33CM"
  },
  "L": {
    "BUST": "80 - 88CM",
    "CUP": "44- 44CM"
  },
  "XL": {
    "BUST": "89 - 98CM"
  }
}
*/
class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.sizeData = this.querySelector('#custom-size');
    this.sizeData2 = this.querySelector('#custom-size2');
    this.bodyMeasurement = this.querySelector('.size-guide__body-measurement table');
    this.sizeTrigger = document.querySelectorAll('[data-size-guide]');
    this.querySelector('.size-guide__close').addEventListener('click', this.close.bind(this));
    this.querySelector('.size-guide__overlay').addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    console.log(this.sizeData, this.sizeData2);
    this.initCustomTable();
    this.addInchesData();
    this.bindEvents();
  }

  open() {
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  bindEvents() {
    this.querySelectorAll('.size-guide__block--sizes button').forEach( button => {
      button.addEventListener('click', e => {
        e.stopPropagation();
        this.updateActiveStyle(e.target);
        const measurement = e.target.dataset.switchTo;
        this.updateTable(measurement, e.target);
      });
    })

    this.sizeTrigger.forEach(triggerBtn => {
      triggerBtn.addEventListener('click', e => {
        this.open();
      });
    });
  }

  updateActiveStyle(button) {
    if (button.parentNode.children.length) {
      Array.from(button.parentNode.children).forEach(child => {
        child.classList.remove('active');
      });
      button.classList.add('active');
    }
  }

  convertToInches(cm) {
    return Math.round(cm * 0.393701);
  }
  
  convertToCM(inch) {
    return Math.round(inch * 2.54);
  }

  sanitizeData(data) {
    return data.toLowerCase().replace('cm', '').replace('"', '').split('-').map(v => parseFloat(v.trim()));
  }

  updateTable(measurement, el) {
    const sizeBlock = el.closest('.size-guide__block');
    const tableHeaders = Array.from(sizeBlock.querySelectorAll('table thead th'));
    const cupColumnIndex = tableHeaders.findIndex(th => th.textContent.trim().toLowerCase() === 'cup');

    const tableData = sizeBlock.querySelectorAll('table tbody tr');
    tableData.forEach((tr, index) => {
      const rowData = tr.querySelectorAll('td');
      rowData.forEach((td, index) => {
        const columnIndex = index + 1 % tableHeaders.length;
        if (columnIndex === cupColumnIndex) { 
          // Skip conversion for 'Cup' column
          return;
        }
    
        const sizes = this.sanitizeData(td.textContent);
        const hasNaN = sizes.some(size => isNaN(size));
        if (hasNaN) {
          return;
        }
        const conversionMethod = measurement === 'inch' ? this.convertToInches : this.convertToCM;
        const converted = sizes.map(size => {
          const convertedSize = conversionMethod(size).toFixed(2);
          return convertedSize.endsWith('.00') ? parseInt(convertedSize, 10) : convertedSize;
        });
        const unit = measurement === 'inch' ? '"' : 'CM';
        td.textContent = converted.length === 2 ? converted.join('-') + unit : converted[0] + unit;
      });
    });
   
  }

	buildTableHeader(data) {
		const flattenHeader = Object.keys(data).map(k => {
			return Object.keys(data[k]).map(v => {
				return v;
			})
		}).flat();
		return [...new Set(flattenHeader)];
	}

  buildCustomSizeTable(sizeData) {
    if ( !sizeData ) return;
    const data = JSON.parse(sizeData.textContent);
		const headers = this.buildTableHeader(data);
		let html = '<thead><tr>';
		html += '<th></th>';
    const table = document.createElement('table');
		headers.map(header => {
			html += `<th>${header}</th>`;
		});
		html += '</tr></thead>';
		html += '<tbody>';
		Object.keys(data).map(key => {
			html += `<tr>
				<th>${key}</th>
			`;
			headers.map(header => {
				html += '<td>';
				if ( data[key][header] ) {
					html += data[key][header];
				}
				html += '</td>';
			});
		});
    html += '</tbody>';
    table.innerHTML = html;
    sizeData.insertAdjacentElement('afterend', table);
  }

  initCustomTable() {
    ['sizeData', 'sizeData2'].forEach(sizeDataProp => {
      if (this[sizeDataProp]) {
        this.buildCustomSizeTable(this[sizeDataProp]);
      }
    });
  }

  addInchesData() {
    if ( !this.bodyMeasurement ) return;
    this.bodyMeasurement.querySelectorAll('td').forEach(td => {
      const inch = parseFloat(td.textContent) * 0.393701;
      td.setAttribute('data-inch', inch.toFixed(1));
      td.setAttribute('data-cm', td.textContent.trim());
    });
  }
}

customElements.define('size-guide', SizeGuide);